import React, {useState, useContext, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import {Colors} from '../../values/colors';
import {Context} from '../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import {estadoOS} from '../ListaOS/requests';
import {toast} from 'react-toastify';

import i18n from '../../i18n';
import ptFlag from '../../assets/images/portugal.png';
import frFlag from '../../assets/images/franca.png';
import usFlag from '../../assets/images/usa.png';
import esFlag from '../../assets/images/ESP.png';
import Logo from '../../assets/images/L.Crm_Azul.png';
import LogoWhite from '../../assets/images/L.Crm_Azul.png';
import ToggleBtnTheme from '../../components/ToggleBtnTheme/index';
import Spinner from '../../components/Spinner';

function Autenticacao() {
    const history = useHistory();
    const {t} = useTranslation();
    const {handleLogin, handleOficina, theme, oficina} = useContext(Context);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [freeze, setFreeze] = useState(false);
    const [loading, setLoading] = useState(false);
    const [idiomaInicial, setIdiomaInicial] = useState('');

    const getIsValid = () => {
        return true;
    };

    useEffect(() => {
        if (navigator.language == 'pt-PT') {
            localStorage.setItem('i18nextLng', 'pt');
            setIdiomaInicial({value: 1, label: t('portugues')});
        } else if (navigator.language == 'fr-FR') {
            localStorage.setItem('i18nextLng', 'pt');
            setIdiomaInicial({value: 2, label: t('frances')});
        } else if (navigator.language == 'en-EN') {
            localStorage.setItem('i18nextLng', 'en');
            setIdiomaInicial({value: 3, label: t('ingles')});
        } else {
            localStorage.setItem('i18nextLng', 'es');
            setIdiomaInicial({value: 4, label: t('espanhol')});
        }
    }, []);

    function mudarIdioma(e) {
        if (e.value == 2) {
            i18n.changeLanguage('fr');
            localStorage.setItem('i18nextLng', 'fr');
            setIdiomaInicial({value: 2, label: t('frances')});
        } else if (e.value == 1) {
            i18n.changeLanguage('pt');
            localStorage.setItem('i18nextLng', 'pt');
            setIdiomaInicial({value: 1, label: t('portugues')});
        } else if (e.value == 3) {
            i18n.changeLanguage('en');
            localStorage.setItem('i18nextLng', 'en');
            setIdiomaInicial({value: 3, label: t('ingles')});
        } else if (e.value == 4) {
            i18n.changeLanguage('es');
            localStorage.setItem('i18nextLng', 'es');
            setIdiomaInicial({value: 4, label: t('espanhol')});
        }
    }

    function handleSubmit(event) {
        let pressedKey = event.key;
        if (pressedKey === 'Enter') {
            event.preventDefault();
            login();
        }
    }

    function login() {
        setFreeze(true);
        setLoading(true);

        const loginWS = new Promise((resolve, reject) => {
            handleLogin(username, password)
                .then(res => {
                    let dados = res.data;
                    if (dados.success) {
                        resolve('Sucesso!');
                        estadoOS(username);
                        localStorage.setItem('dossier', 'DMVTMA');
                        history.push('/Dashboard');
                        resolve(t('toastLoginSucesso'));
                    } else {
                        let mensagem = dados.error_object.errorMessage;
                        let resposta = '';
                        if (mensagem) resposta = mensagem;
                        if (!mensagem) resposta = t('toastErro');

                        reject(resposta);
                    }
                    setFreeze(false);
                    setLoading(false);
                })
                .catch(e => {
                    reject(t('toastErro'));
                    setFreeze(false);
                    setLoading(false);
                });
        });

        toast.promise(
            loginWS,
            {
                success: t('toastLoginSucesso'),
                error: {
                    render({data}) {
                        return data;
                    },
                },
            },
            {autoClose: 900},
        );
    }

    return (
        <div className="flex flex-row justify-center items-center w-[100vw] h-[100vh] bg-blue-900  dark:bg-gray-900">
            <div className=" flex w-full md:max-w-sm max-w-xs p-4 bg-white border border-gray-200 rounded-xl shadow sm:p-6 md:p-8 dark:bg-gray-700 dark:border-gray-700">
                <form className="space-y-6" onSubmit={login}>
                    <div className="flex items-center justify-center">
                        {theme === 'dark' ? <img width={'80%'} className="p-5" src={LogoWhite} /> : <img width={'80%'} className="p-5" src={Logo} />}
                        {/* <img width={"80%"} className="p-5" src={Logo} /> */}
                        <div style={{marginBottom: '2rem'}}>
                            <ToggleBtnTheme />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('utilizador')}
                        </label>
                        <input
                            type="username"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            onKeyDown={handleSubmit}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                            required={true}
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('palavraPasse')}
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            onKeyDown={handleSubmit}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                            required={true}
                        />
                    </div>
                    {loading ? (
                        <div className="text-center">
                            <Spinner animation="border" style={{marginTop: 20}} />
                        </div>
                    ) : (
                        <button
                            disabled={!getIsValid}
                            // type="submit"
                            onClick={() => login()}
                            className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                            {t('login')}
                        </button>
                    )}

                    <div className="flex flex-row justify-center">
                        <button
                            onClick={() => {
                                mudarIdioma({value: 2, label: t('frances')});
                            }}
                            type="button"
                            className="flex flex-col mr-5  items-center justify-center max-w-sm  bg-white border border-gray-200 hover:bg-slate-400 focus:ring-4 focus:outline-none rounded-xl shadow   dark:bg-[#7698c2] dark:border-[#516885] h-[50px] w-[50px]">
                            <img width={'100%'} style={{padding: 10}} src={frFlag} />
                        </button>
                        <button
                            onClick={() => {
                                mudarIdioma({value: 1, label: t('portugues')});
                            }}
                            type="button"
                            className="flex flex-col mr-5 items-center justify-center max-w-sm  bg-white border rounded-xl border-gray-200 hover:bg-slate-400 focus:ring-4 focus:outline-none shadow   dark:bg-[#7698c2] dark:border-[#516885] h-[50px] w-[50px]">
                            <img width={'100%'} style={{padding: 8}} src={ptFlag} />
                        </button>
                        <button
                            onClick={() => {
                                mudarIdioma({value: 3, label: t('ingles')});
                            }}
                            type="submit"
                            className="flex flex-col mr-5 items-center justify-center max-w-sm  bg-white border rounded-xl border-gray-200 hover:bg-slate-400 focus:ring-4 focus:outline-none shadow   dark:bg-[#7698c2] dark:border-[#516885] h-[50px] w-[50px]">
                            <img width={'100%'} style={{padding: 8}} src={usFlag} />
                        </button>
                        <button
                            onClick={() => {
                                mudarIdioma({value: 4, label: t('espanhol')});
                            }}
                            type="submit"
                            className="flex flex-col  items-center justify-center max-w-sm  bg-white border rounded-xl border-gray-200 hover:bg-slate-400 focus:ring-4 focus:outline-none shadow   dark:bg-[#7698c2] dark:border-[#516885] h-[50px] w-[50px]">
                            <img width={'100%'} style={{padding: 8}} src={esFlag} />
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Autenticacao;
